import { gql } from '@apollo/client'

export const UI_FLAGS = gql`
  query uiFlags {
    uiFlags {
      showVideoCallSteloUpsellModal
      showVideoCallSteloUpsellPersistentBanner
      showReferredToPurchaseModal
      showChurnFeedbackModal
      showProductMarketFitSurvey
      showNetPromoterScoreSurvey
      showStressManagementBanner
      showLabResultAnalysisCompleteBanner
      showLabResultAnalysisFailedBanner
      showNutritionistSwitchModal
      showPostCoachSwitchSurvey
      rateAppEligible
      showReferralBanner
      showReferralPopup
      showFullscriptLabsUpsellModal
      showFullscriptLabsBanner
      showFreeCallTrialUpsellPopup
      showFreeCallTrialUpsellBanner
      showUnifiedOnboarding
      showOnboardingInsuranceSurvey
      showAddInsuranceUpsells
      insuranceInformationSubmitted
      showWeightLossRecurringCallsBanner
      showLibreIndirectSyncConfirmation
      showNoraHomeTutorial
    }
  }
`
